module.exports = __webpack_public_path__ + "static/media/bootstrap.95e8c450.svg";